const isCustomColorValue = (color) =>
  typeof color === 'string' && color.trim().startsWith('#');

export const getTypographyColorProps = (color) => {
  if (isCustomColorValue(color)) {
    return {
      typographyColor: undefined,
      colorStyle: { color },
    };
  }

  return {
    typographyColor: color,
    colorStyle: {},
  };
};

